import React from 'react';
import { IFilterPredicate } from '../../../types';
import { UnreachableCaseError } from 'ts-essentials';
import FilterWidgetArrayObjectPredicate from './FilterWidgetArrayObjectPredicate';
import FilterWidgetSinglePredicate from './FilterWidgetSinglePredicate';
import { useWatch } from 'react-hook-form';
import useFilterWidgetFormContext from '../../../utils/useFilterWidgetFormContext';

interface IProps {
  onUpdatePredicate: (newPredicate: IFilterPredicate) => void;
  conditionIndex: number;
  predicateIndex: number;
  onResetField: () => void;
  onRemove: () => void;
  disableRemove: boolean;
  allowMorePredicates: boolean;
  onAddPredicate: () => void;
}

const FilterWidgetPredicate = ({
  onUpdatePredicate,
  conditionIndex,
  predicateIndex,
  onResetField,
  onRemove,
  disableRemove,
  allowMorePredicates,
  onAddPredicate,
}: IProps) => {
  const { control } = useFilterWidgetFormContext();

  const predicate = useWatch({
    name: `conditions.${conditionIndex}.predicates.${predicateIndex}`,
    control,
  });

  if (predicate.__typename === 'SimplePredicate') {
    return (
      <FilterWidgetSinglePredicate
        rootPredicate={predicate}
        onUpdateRootPredicate={onUpdatePredicate}
        conditionIndex={conditionIndex}
        predicateIndex={predicateIndex}
        onResetField={onResetField}
        onRemove={onRemove}
        disableRemove={disableRemove}
        allowMorePredicates={allowMorePredicates}
        onAddPredicate={onAddPredicate}
      />
    );
  } else if (predicate.__typename === 'ArrayObjectPredicate') {
    return (
      <FilterWidgetArrayObjectPredicate
        rootPredicate={predicate}
        onUpdateRootPredicate={onUpdatePredicate}
        conditionIndex={conditionIndex}
        predicateIndex={predicateIndex}
        onRemove={onRemove}
        disableRemove={disableRemove}
        allowMorePredicates={allowMorePredicates}
        onAddPredicate={onAddPredicate}
      />
    );
  } else {
    throw new UnreachableCaseError(predicate);
  }
};

export default FilterWidgetPredicate;
